import { Wind } from "lucide-react";
import { aqiInfo } from "../lib/weather";

const Pollutant = ({ label, value, unit }) => (
  <div className="rounded-xl bg-secondary/40 p-2.5 text-center">
    <div className="text-[10px] uppercase tracking-wider text-muted-foreground">{label}</div>
    <div className="text-sm font-bold num mt-0.5">{value}</div>
    <div className="text-[9px] text-muted-foreground">{unit}</div>
  </div>
);

export const AqiCard = ({ aqi }) => {
  if (!aqi) return null;
  const info = aqiInfo(aqi.aqi);
  const c = aqi.components;

  return (
    <div className="glass-card p-5 sm:p-6" data-testid="aqi-index-card">
      <div className="flex items-center gap-2 mb-4">
        <Wind className="w-4 h-4 text-primary" />
        <h3 className="text-base font-semibold">Kualitas Udara</h3>
      </div>

      <div className="flex items-center gap-4">
        <div
          className="relative w-20 h-20 rounded-2xl grid place-items-center shrink-0"
          style={{ background: `${info.color}22`, border: `2px solid ${info.color}` }}
        >
          <span className="text-3xl font-black num" style={{ color: info.color }}>
            {aqi.aqi}
          </span>
        </div>
        <div>
          <div className="text-lg font-bold" style={{ color: info.color }}>
            {info.label}
          </div>
          <div className="text-xs text-muted-foreground">{info.desc}</div>
        </div>
      </div>

      <div className="mt-4 h-2 rounded-full bg-gradient-to-r from-green-500 via-yellow-500 via-orange-500 to-purple-600 relative">
        <div
          className="absolute -top-1 w-3.5 h-3.5 rounded-full bg-white border-2 border-foreground"
          style={{ left: `calc(${((aqi.aqi - 1) / 4) * 100}% - 7px)` }}
        />
      </div>

      <div className="grid grid-cols-4 gap-2 mt-4">
        <Pollutant label="PM2.5" value={c.pm2_5} unit="µg/m³" />
        <Pollutant label="PM10" value={c.pm10} unit="µg/m³" />
        <Pollutant label="O₃" value={c.o3} unit="µg/m³" />
        <Pollutant label="NO₂" value={c.no2} unit="µg/m³" />
      </div>
    </div>
  );
};
